module.exports = __webpack_public_path__ + "static/media/reestructura_bco.ea632f83.svg";